import { useState, useEffect, useContext } from 'react'
import { context } from 'components/Form'
import { runValidations } from 'components/Form/validations'
import uniqueId from 'lodash/uniqueId'

import _set from 'lodash/set'
import get from 'lodash/get'
import toPath from 'lodash/toPath'

const set = (obj, path, val) => {
  const parts = toPath(path)
  const last = parts.pop()
  if (last) {
    return _set(obj, path, val)
  } else {
    const array = get(obj, parts.join('.'), [])
    array.push(val)
    _set(obj, parts.join('.'), array)
    return obj
  }
}

export default function useField({ validate, name, defaultValue }) {

  const form = useContext(context)
  const [value, _setValue] = useState(defaultValue || '')
  const [id] = useState(uniqueId('field-'))

  useEffect(() => {
    if (validate) {
      form.addValidation(id, () => {
        return runValidations(validate)(value)
      })
    }

    if (name) {
      form.addField(id, name, data => {
        return set(data, name, value)
      })
    }

    return () => {
      if (validate) {
        form.removeValidation(id)
      }
  
      if (name) {
        form.removeField(id, name)
      }
    }
  }, [validate, form, name, id, value])

  useEffect(() => {
    return () => {
      form.updateError(id) // Clear existing validation error on unmount
    }
  }, [])

  const setValue = newValue => {
    _setValue(newValue)
    if (form.errors[id]) {
      form.updateError(id, runValidations(validate)(newValue))
    }
  }

  const setChanged = () => {
    form.setChanged()
  }

  const revalidate = () => {
    if (!form.loading && validate) {
      form.updateError(id, runValidations(validate)(value))
    }
  }

  const error = form.errors[id]

  const fieldId = (form.formId && name && `${form.formId}-${name}`) || id

  return  {
    value, setValue, setChanged, error, revalidate, id: fieldId, allErrors: form.errors, formLoading: form.loading,
  }
}